/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileJavaShortcut = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v10H4zm11 3.414V7h1.586zM18 20v-1h2v3H8v-2z" />
        <path d="M7.771 16.84v-.919c.197.085.371.148.523.188.156.04.304.06.442.06.487 0 .73-.234.73-.703V13l-.89-.288v-.583h1.936v3.43c0 .487-.143.865-.43 1.133-.28.268-.676.402-1.185.402a2.8 2.8 0 0 1-.61-.067 1.716 1.716 0 0 1-.516-.188zm3.019.16 1.85-4.87h1.012L15.514 17H14.35l-.322-.998H12.23l-.32.998zm1.723-1.883h1.226l-.617-1.916zM16.866 17l-1.796-4.87h1.18l1.138 3.584 1.152-3.585h1.133L17.877 17zm2.365 0 1.85-4.87h1.011L23.955 17h-1.166l-.322-.998h-1.795L20.35 17zm1.722-1.883h1.226l-.616-1.916zM2.474 17.474 1 16h5v5l-1.653-1.653c-1.27.777-1.936 1.982.672 3.653 0 0-4.56-.436-3.298-4.29 0 0 .18-.576.753-1.236z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileJavaShortcut as FileJavaShortcut };
